<template>
  <div> 电子档案室 -> 电子备案库 ->  共享资料库 </div>
</template>
<style lang="less" type="text/less" scoped></style>
<script>
export default {
  name: 'DatabaseShared'
}
</script>
